import React, { useEffect, useRef, useState } from "react";
import { Eye, EyeSlash } from "react-bootstrap-icons";
import { Form, InputGroup, Button } from "react-bootstrap";
// import FingerprintJS from "@fingerprintjs/fingerprintjs";
import * as FingerprintJS from "@fingerprintjs/fingerprintjs-pro";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import Cookies from "universal-cookie";
import slsLogo from "./../../assets/images/loanlinq.png";
import useAuth from "../../auth/hooks/useAuth";
import {
  deploymentTypes,
  selected_authentication_server,
  servers,
  serverType,
} from "../../deployment-config";
import {
  setAccountOptions,
  setDemoAccount,
  setLenderID,
  setRoleOptions,
  setSelectedAccount,
  setSelectedRole,
} from "../../store/reducers/accountSlice";
import { FloatLabelInput, LoadingButton } from "../../Utils/CustomComponent";
import { setReportList, setRoute } from "../../store/reducers/reducer-auth";
import ForgotPasswordModal from "./ForgotPasswordModal";
import { setToken } from "../../store/reducers/reducer-tokens";
import urls from "../../Utils/urls";
import PopupWrapper from "../../components/PopupWrapper";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import "./login.css";
import Footer from "./Footer/Footer";
import axiosInstance from "../../axios";
// import { useMsal } from "@azure/msal-react";
// import GoogleReCAPTCHA from "../../components/GoogleReCAPTCHA";

let server_address =
  serverType === deploymentTypes.development
    ? servers.development
    : deploymentTypes.localDevelopment
      ? servers.localDevelopment
      : servers.production;

export const environment_hostname = `https://${server_address}/api/v1`;

const ARROW_COOKIE_KEY = "trustedDeviceArrowShown";
const ARROW_EXPIRY_DAYS = 30;

const LoginComponent = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    // setValue,
  } = useForm();
  const dispatch = useDispatch();
  const [otpReceived, setOtpReceived] = useState("");
  const [otpEntered, setOtpEntered] = useState("");
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [isOtpStage, setIsOtpStage] = useState(false);
  const [afterOtpLoading, setAfterOtpLoading] = useState(false);
  const [disableFWS, setDisableFWS] = useState(false);
  const [promptFail, setPromptFail] = useState(null);
  // const [firstLogin, setFirstLogin] = useState(true);
  const [trustedDevice, setTrustedDevice] = useState(false);
  const [userId, setUserId] = useState(null);
  const [firstStepDone, setFirstStepDone] = useState(false);

  // const { instance } = useMsal();
  const setUserLoggedIn = useSetUserLoggedIn();
  const [cookies] = useState(new Cookies());
  const watchValue = watch();
  // const email = watch("email");
  // const isSuperiorLoanEmail =
  //   email && email.includes("@superiorloanservicing.com");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [showArrow, setShowArrow] = useState(false);
  const [arrowPosition, setArrowPosition] = useState({ top: -25, left: -30 });
  const checkboxRef = useRef(null);
  const navigate = useNavigate();

  const intervalId = setInterval(() => {
    if (isLoggedIn) {
      if (!localStorage.getItem("user")) {
        setIsLoggedIn(false);
        setDisableFWS(false);
      }
    }
  }, 1000);

  useEffect(
    (loggedIn) => {
      if (loggedIn) {
        // eslint-disable-next-line no-unused-vars
        const loginBackground = "";
      }
      if (localStorage.getItem("user")) {
        setIsLoggedIn(true);
        setTimeForLoginSession();
      } else {
        setIsLoggedIn(false);
      }
      return () => {
        if (intervalId != null) {
          clearInterval(intervalId);
        }
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isLoggedIn],
  );

  useEffect(() => {
    const hasSeenArrow = cookies.get(ARROW_COOKIE_KEY);

    if (!hasSeenArrow && showOtpInput) {
      setShowArrow(true);

      const timer = setTimeout(() => {
        setShowArrow(false);
        // Set cookie to expire in 30 days
        const expiryDate = new Date();
        expiryDate.setDate(expiryDate.getDate() + ARROW_EXPIRY_DAYS);
        cookies.set(ARROW_COOKIE_KEY, "true", {
          path: "/",
          expires: expiryDate,
        });
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [showOtpInput]);

  async function getFingerPrint() {
    try {
      const fp = await FingerprintJS.load({
        apiKey: "xzMefaISTzTk3XMDEH6r",
        endpoint: "https://metrics.loanlinq.com",
        scriptUrlPattern: [
          "https://metrics.loanlinq.com/web/v<version>/<apiKey>/loader_v<loaderVersion>.js",

          // The default endpoint will be used if the primary fails
          FingerprintJS.defaultScriptUrlPattern,
        ],
      });
      const result = await fp.get();
      const fingerprint = result.visitorId;

      return fingerprint;
    } catch (error) {
      console.error(error);
    }
  }

  const handleInitialLogin = async (email, password) => {
    setDisableFWS(true);
    try {
      const fingerprint = await getFingerPrint();

      const res = await axios.post(urls.admin.getAuthToken, {
        username: email,
        password: password,
        fingerprint: fingerprint,
        userId: userId,
      });

      // const decodedOtp = atob(res.data.otp); // Decode OTP
      // // console.log(decodedOtp);
      // setOtpReceived(decodedOtp);
      setUserId(res.data.userid);
      await setUser({ res, setIsLoggedIn, cookies, dispatch });
      // setShowOtpInput(true);
      // setIsOtpStage(true);
      if (res.data.axiosdata?.is_trusted) {
        await finalApiCall();
      } else if (!res.data.axiosdata?.is_trusted) {
        // const decodedOtp = atob(res.data.otp); // Decode OTP
        // console.log(decodedOtp);
        // setOtpReceived(decodedOtp);
        setShowOtpInput(true);
        setIsOtpStage(true);
        setPromptFail(null);
      }
    } catch (error) {
      console.error("Login failed:", error);
      setPromptFail("Invalid email and/or password. Please try again.");
      setDisableFWS(false);
    }
  };

  async function finalApiCall() {
    try {
      if (trustedDevice) {
        await trustDevice();
      }

      const res2 = await axios.post(
        selected_authentication_server.access_account.endpoint,
        { userid: localStorage.getItem("apex_userid") },
        selected_authentication_server.access_account.headers,
      );

      setUserLoggedIn({ res: res2 });
    } catch (error) {
      console.error(error);
    }
  }

  const onSubmit = async (data) => {
    localStorage.setItem("email_for_forgot_password", data.email);
    setDisableFWS(true);
    if (isOtpStage) {
      if (otpEntered?.length === 6) {
        try {
          setAfterOtpLoading(true);
          // First API call to validate OTP
          const data2 = {
            UserName: data.email,
            otp: otpEntered,
          };
          const res3 = await axios.post(
            urls.admin.validateLoginOTP,
            data2,
            selected_authentication_server.access_account.headers,
          );
          // Second API call if OTP is correct
          if (res3.status == 200) {
            if (trustedDevice) {
              await trustDevice();
            }

            const res2 = await axios.post(
              selected_authentication_server.access_account.endpoint,
              { userid: localStorage.getItem("apex_userid") },
              selected_authentication_server.access_account.headers,
            );

            setUserLoggedIn({ res: res2 });
          }
        } catch (error) {
          console.error("Failed to verify user:", error);
          setPromptFail("Failed to verify OTP. Please try again.");
        }
      } else {
        // setPromptFail("Invalid OTP. Please try again.");
        setPromptFail("Please enter a valid 6-digit OTP.");
      }
      setAfterOtpLoading(false);
    } else {
      handleInitialLogin(data.email, data.password);
    }
  };

  async function onSubmit1(data) {
    setDisableBtn(true);
    try {
      const res = await axios.get(
        urls.admin.getUserByEmail(data.email),
        selected_authentication_server.access_account.headers,
      );

      setUserId(res.data.items?.[0]?.user_id);
    } catch (error) {
      console.error(error);
    } finally {
      setDisableBtn(false);
      setFirstStepDone(true);
    }
  }

  async function trustDevice() {
    try {
      const fingerprint = await getFingerPrint();

      const data = JSON.stringify({ userId, fingerprint });
      await axios.post(urls.dashboard.registerDevice, data, {
        headers: { "Content-Type": "application/json" },
      });

      toast.success("Device successfully registered as a trusted device!", {
        ...commonToast,
      });
    } catch (error) {
      console.error(error);
      toast.error("Trusted device registration failed!", {
        ...commonToast,
      });
    }
  }

  // const ssoLogin = async () => {
  //   const res = await instance.loginPopup({
  //     scopes: ["User.Read"],
  //   });
  //   if (res) {
  //     const res2 = await axios.get(
  //       `${selected_authentication_server.user_by_email.endpoint}${res.account.username}`,
  //       selected_authentication_server.user_by_email.headers
  //     );

  //     if (res2?.data?.count > 0) {
  //       const res3 = await axios.post(
  //         selected_authentication_server.access_account.endpoint,
  //         { userid: res2?.data?.items?.[0]?.user_id },
  //         selected_authentication_server.access_account.headers
  //       );
  //       setUserLoggedIn({ res: res3 });
  //     } else {
  //       setPromptFail("No Authorised. Please try again.");
  //     }
  //   } else {
  //     setPromptFail("No Authorised. Please try again.");
  //   }
  // };
  // const handleCaptchaSuccess = (captchaValue) => {
  //   setValue("recaptcha", captchaValue, { shouldValidate: true });
  // };
  return (
    <Background fromLogin={true}>
      {/* <LoginPopup showPopup={showPopup} setShowPopup={setShowPopup} /> */}
      <form className="w-75">
        <h3>Customer Portal</h3>
        <p className="pb-5 mb-3">Please enter your login details to proceed.</p>

        <div className="form-outline mb-5">
          <FloatLabelInput
            register={{
              ...register("email", {
                required: true,
                pattern:
                  // eslint-disable-next-line no-useless-escape
                  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              }),
            }}
            label={"Email"}
            value={watchValue?.email}
            disabled={firstStepDone ? true : disableFWS}
            defaultValue={""}
            error={errors.email ? "Email Required" : ""}
            type="email"
          />
        </div>

        {firstStepDone ? (
          <div className="form-outline mb-1" style={{ position: "relative" }}>
            {/* <InputGroup> */}
            <FloatLabelInput
              register={{ ...register("password", { required: true }) }}
              label={"Password"}
              value={watchValue?.password}
              disabled={disableFWS}
              defaultValue={""}
              error={errors.password ? "Password Required" : ""}
              type={showPassword ? "text" : "password"}
            />
            <div
              style={{
                position: "absolute",
                top: "15px",
                right: "1rem",
                cursor: "pointer",
              }}
              onClick={() => setShowPassword((pass) => !pass)}
            >
              {showPassword ? <Eye size={20} /> : <EyeSlash size={20} />}
            </div>
            {/* </InputGroup> */}
          </div>
        ) : null}
        {/* <GoogleReCAPTCHA handleCaptchaSuccess={handleCaptchaSuccess} /> */}
        {/* <input
          type="hidden"
          {...register("recaptcha", { required: "ReCAPTCHA is required" })}
        /> */}

        {/* Display error if ReCAPTCHA is not solved */}
        {/* {errors.recaptcha && <p>{errors.recaptcha.message}</p>} */}
        {firstStepDone && (
          <div className="mb-4">
            <ForgotPasswordModal />
          </div>
        )}
        {/* <div>
          This is the login page for customers only. If you are an employee,
          please use the employee{" "}

            login
          </a>{" "}
          form.
        </div> */}
        <div className="form-outline mb-1">
          {showOtpInput && (
            <>
              <OTPInputComponent
                setOtpEntered={setOtpEntered}
                setOtpReceived={setOtpReceived}
                onClick={() =>
                  handleInitialLogin(watchValue?.email, watchValue?.password)
                }
              />
            </>
          )}
        </div>

        <div className="text-center pt-1 mt-5 mb-5 pb-1">
          {showOtpInput ? (
            <>
              <LoadingButton
                className="btn btn-primary w-100 btn-block fa-lg gradient-custom-2 mb-3 text-white"
                type="button"
                onClick={handleSubmit(onSubmit)}
                title={"Verify OTP and Continue"}
                disabled={afterOtpLoading}
                loading={afterOtpLoading}
              />
              {/* <TrustDevicePrompt userId={userId} /> */}
              <div
                className="text-start linkClick text-decoration-underline border shadow-sm p-3"
                style={{ position: "relative" }}
              >
                <Form.Check
                  type={"checkbox"}
                  ref={checkboxRef}
                  id={"trusted-device"}
                  label={`Remember this device for next 30 days`}
                  checked={trustedDevice}
                  disabled={afterOtpLoading}
                  onChange={(e) => {
                    setTrustedDevice(e.target.checked);
                  }}
                />

                {showArrow && (
                  <div
                    className={`tooltip-container`}
                    style={{
                      position: "absolute",
                      top: `${arrowPosition.top}px`,
                      left: `-235px`, // adjust based on tooltip width
                      zIndex: 1000,
                      pointerEvents: "none",
                    }}
                  >
                    <div className="tooltip-box tooltip-right-arrow">
                      Click this checkbox to set your device as trusted for next
                      30 days
                    </div>
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              {firstStepDone ? (
                <LoadingButton
                  className="btn btn-primary w-100 btn-block fa-lg gradient-custom-2 mb-3 text-white"
                  type="submit"
                  onClick={handleSubmit(onSubmit)}
                  disabled={disableFWS}
                  loading={disableFWS}
                  title={"Continue"}
                />
              ) : (
                <LoadingButton
                  className="btn btn-primary w-100 btn-block fa-lg gradient-custom-2 mb-3 text-white"
                  type="submit"
                  onClick={handleSubmit(onSubmit1)}
                  disabled={disableBtn}
                  loading={disableBtn}
                  title={"Next"}
                />
              )}
              {/* {!isTrustedDevice && (
                <div className="text-start linkClick text-decoration-underline">
                  <Form.Check
                    type={"checkbox"}
                    id={"trusted-device"}
                    label={`Set As Trusted Device`}
                    checked={trustedDevice}
                    onChange={(e) => {
                      setTrustedDevice(e.target.checked);
                    }}
                  />
                </div>
              )} */}
            </>
          )}
          {/* {isSuperiorLoanEmail && (
            <>
              <div>OR</div>
              <Button
                className="d-flex justify-content-center align-items-center w-100 border font-weight-bold mb-5"
                type="button"
                variant="secondary"
                disabled={disableFWS}
                onClick={ssoLogin}
              >
                <div className="me-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 16 16"
                    id="microsoft"
                    width="30px"
                  >
                    <path
                      fill="#4CAF50"
                      d="M8.5 7.5H16v-7a.5.5 0 0 0-.5-.5h-7v7.5z"
                    ></path>
                    <path
                      fill="#F44336"
                      d="M7.5 7.5V0h-7a.5.5 0 0 0-.5.5v7h7.5z"
                    ></path>
                    <path
                      fill="#2196F3"
                      d="M7.5 8.5H0v7a.5.5 0 0 0 .5.5h7V8.5z"
                    ></path>
                    <path
                      fill="#FFC107"
                      d="M8.5 8.5V16h7a.5.5 0 0 0 .5-.5v-7H8.5z"
                    ></path>
                  </svg>
                </div>

                <div style={{ fontWeight: "700" }}>
                  Continue with Microsoft(SSO)
                </div>
              </Button>
            </>
          )} */}
          {promptFail && (
            <div className="alert alert-error" role="alert">
              {promptFail}
            </div>
          )}
          <br />
        </div>

        {/* <div className="d-flex align-items-center justify-content-center pb-4">
          <div className="mb-0 me-4">New here?</div>
          <div
            role="button"
            className="linkClick"
            onClick={() => {
              navigate("/register");
            }}
          >
            Register
          </div>
        </div> */}
        <div className="pb-4 fw-bold">
          {/* Please login with your{" "}
          <a
            href="https://servicing.loans"
            className="linkClick text-decoration-none"
          >
            https://servicing.loans
          </a>{" "} */}
          Please log in with your registered email address. If you need
          assistance please call 888-587-9757
          {/* user account (email) for onboarding. If you need assistance please
          call 888-587-9757 */}
        </div>
      </form>
      {/* <ForgotPasswordModal /> */}
    </Background>
  );
};
export default LoginComponent;
export const Background = ({ children, showFooter = true, logo = null, fromLogin = false }) => {
  return (
    <div
      style={{
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
      }}
    >
       {/* {fromLogin && (
        <div className="bg-yellow overflow-hidden">
          <span className="d-flex py-3 my-marquee fs-5">
            Hello, We are currently performing maintenance in our LoanlinQ
            portal which may cause OTPs to be delayed or, in some cases, not
            delivered. If you do not receive your OTP, please try again after
            some time. We apologize for the inconvenience and appreciate your
            patience while we complete this maintenance. Thank you for your
            understanding.
          </span>
        </div>
      )} */}
      {/* <div className=""> */}

      <section
        className="h-100 gradient-form d-sm-flex align-items-sm-center"
        style={{
          minHeight: "100vh",

          backgroundBlendMode: "multiply",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container h-100">
          <div className="row d-flex justify-content-center align-items-center h-100 h-sm-50">
            <div className="col-xl-12 text-black row h-sm-50">
              <div className="col-lg-6 d-flex align-items-center justify-content-center">
                <div className="card-body p-md-5 mx-md-4 w-100">
                  <div className="">
                    <img
                      src={logo ? logo : slsLogo}
                      style={{ width: "385px" }}
                      alt="logo"
                    />
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-lg-6 d-flex align-items-center justify-content-center gradient-custom-2 d-lg-flex ps-5 text-start">
                {children}
              </div>
            </div>
            {/* {showFooter && <FooterComp />} */}
            {showFooter && <Footer />}
          </div>
          <style>
            {`
            .gradient-custom-2 {
              background-size: cover;
              background-postion: center;
              background-repeat: no-repeat;
              background-blend-mode: overlay;
              }
              @media (min-width: 768px) {
              .gradient-form {
              height: 100vh !important;
              }
              }
              @media (min-width: 769px) {
              .gradient-custom-2 {
              border-top-right-radius: .3rem;
              border-bottom-right-radius: .3rem;
              }
              }
            `}
          </style>
        </div>
      </section>
    </div>
  );
};
export const setUser = async ({ res, setIsLoggedIn, cookies, dispatch }) => {
  localStorage.setItem(
    "AUTH-TOKEN",
    JSON.stringify({ ...res.data, expiration: Date.now() }),
  );
  localStorage.setItem("apex_userid", res.data.userid);
  dispatch(setToken(JSON.stringify(res.data)));
  setIsLoggedIn(true);
  // cookies.set(
  //   "login",
  //   res.data.session_name +
  //     "=" +
  //     res.data.sessid +
  //     "; Expires=" +
  //     res.headers["expires"]
  // );
  cookies.set("login", JSON.stringify(res.data) + "; Expires=" + 86400000);
  localStorage.setItem("user", JSON.stringify(res));
  localStorage.setItem("setupTime", new Date().getTime());

  await new Promise((resolve) => setTimeout(resolve, 4000));
};
export const useSetUserLoggedIn = () => {
  const location = useLocation();
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const setUserLoggedIn = ({ res }) => {
    if (
      res.data !== undefined &&
      res.data != null &&
      res.data !== "" &&
      typeof res.data == "object"
    ) {
      const filteredAccountOption =
        res.data?.account?.filter(
          (v, i, a) =>
            a.findIndex((v2) => v2.recid === v.recid && v2.type === v.type) ===
            i,
        ) || [];
      const filteredRoleOption =
        res?.data?.role?.filter(
          (v, i, a) =>
            a?.findIndex((v2) => v2?.role_name === v?.role_name) === i,
        ) || [];
      const authObj = {
        isAuthenticated: true,
        roles: filteredRoleOption?.map((data) => data?.role_name),
        user: {
          username: res?.data?.username,
          details: {
            username: res?.data?.username,
            email: res?.data?.email,
            roles: JSON.stringify(filteredRoleOption),
          },
        },
      };
      localStorage.setItem(
        "accessed_user",
        JSON.stringify({
          ...res.data,
          account: filteredAccountOption,
        }),
      );

      const isDemoAccount =
        res?.data?.demo_yn?.toLowerCase() === "y" ? true : false;
      dispatch(setDemoAccount(isDemoAccount));

      localStorage.setItem("authentication", JSON.stringify(authObj));
      setAuth(authObj);
      localStorage.setItem(
        "user-details",
        JSON.stringify({
          username: res?.data?.username,
          role: filteredRoleOption?.[0]?.role_name,
          selectedAccount: {
            value: filteredAccountOption?.[0]?.recid,
            label: filteredAccountOption?.[0]?.account,
          },
          details: {
            username: res?.data?.username,
            email: res?.data?.email,
            roles: JSON.stringify(
              filteredRoleOption?.map((data) => ({
                ...data,
                nav_menu: data?.nav_menu?.sort(
                  (a, b) => a?.menu_order - b?.menu_order,
                ),
              })),
            ),
          },
        }),
      );
      if (filteredRoleOption.length) {
        // const menuNameList = filteredRoleOption[0]?.nav_menu?.map(
        //   ({ menu_name }) => menu_name
        // );
        // const reportNameList = filteredRoleOption[0].report_list;

        // dispatch(setReportList(reportNameList));
        // dispatch(setRoute(menuNameList));

        const accountOption = [
          ...new Set(filteredAccountOption.map((data) => data.type)),
        ];

        if (!accountOption?.length) {
          const menuNameList = filteredRoleOption[0]?.nav_menu?.map(
            ({ menu_name }) => menu_name,
          );
          const reportNameList = filteredRoleOption[0].report_list;

          dispatch(setReportList(reportNameList));
          dispatch(setRoute(menuNameList));
        } else {
          const menuNameList = filteredRoleOption
            ?.filter((item) => accountOption.includes(item.role_type))[0]
            ?.nav_menu?.map(({ menu_name }) => menu_name);

          const reportNameList = filteredRoleOption?.filter((item) =>
            accountOption.includes(item.role_type),
          )[0].report_list;

          dispatch(setReportList(reportNameList));
          dispatch(setRoute(menuNameList));
        }

        const roleOptions = filteredRoleOption
          ?.filter((item) => accountOption.includes(item.role_type))
          ?.map((data) => ({
            value: data.role_type,
            label: data.role_name,
            id: data.role_id,
          }));

        const isBorrower = roleOptions[0]?.label?.includes("Borrower");
        const accountOptions = filteredAccountOption
          ?.filter((data) => data.type === roleOptions[0].value)
          ?.map((data) => ({
            label:
              // isBorrower && data?.paidoff_yn?.toLowerCase() === "y"
              //   ? `${data?.fullname} : ${data?.account}`
              //   :
              `${data?.fullname} - ${data?.account}`,
            value: data.recid,
            databasename: data.databasename,
          }));

        const paidOffYes = filteredAccountOption
          ?.filter(
            (data) =>
              data.type === roleOptions[0].value &&
              data.paidoff_yn?.toLowerCase() === "y",
          )
          ?.map((data) => ({
            label:
              // isBorrower && data?.paidoff_yn?.toLowerCase() === "y"
              //   ? `${data?.fullname} : ${data?.account} : ${data.paidoffdate}`
              //   :
              `${data?.fullname} - ${data?.account}`,
            value: data.recid,
            databasename: data.databasename,
          }));

        const paidOffNo = filteredAccountOption
          ?.filter(
            (data) =>
              data.type === roleOptions[0].value &&
              data.paidoff_yn?.toLowerCase() === "n",
          )
          ?.map((data) => ({
            label:
              // isBorrower && data?.paidoff_yn?.toLowerCase() === "y"
              //   ? `${data?.fullname} : ${data?.account} : ${data.paidoffdate}`
              //   :
              `${data?.fullname} - ${data?.account}`,
            value: data.recid,
            databasename: data.databasename,
          }));

        const sortedAccountOptions = [...paidOffNo, ...paidOffYes];

        dispatch(setRoleOptions(roleOptions));
        if (isBorrower) {
          dispatch(setAccountOptions(sortedAccountOptions));
          dispatch(setSelectedAccount(sortedAccountOptions[0]));
          dispatch(setSelectedRole(roleOptions[0]));
          dispatch(setLenderID(sortedAccountOptions[0]?.value));
        } else {
          dispatch(setAccountOptions(accountOptions));
          dispatch(setSelectedAccount(accountOptions[0]));
          dispatch(setSelectedRole(roleOptions[0]));
          dispatch(setLenderID(accountOptions[0]?.value));
        }
      } else {
        navigate("/add_account");
      }
    }
    if (res.data != null) {
      if (!res?.data?.role) {
        navigate("/add_account");
      } else {
        if (
          localStorage.getItem("authentication").isAuthenticated === "true" &&
          !localStorage.getItem("accessed_user") &&
          location.pathname !== "/add_account"
        ) {
          navigate("/add_account");
        } else {
          navigate("/");
        }
      }
    }
  };

  return setUserLoggedIn;
};

const cleanLocalStorage = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("setupTime");
};
const setTimeForLoginSession = () => {
  var hours = 1;
  var now = new Date().getTime();
  var setupTime = localStorage.getItem("setupTime");
  if (setupTime == null) {
  } else {
    if (now - setupTime > hours * 60 * 60 * 1000) {
      cleanLocalStorage();
    }
  }
};

export const OTPInputComponent = ({
  setOtpEntered,
  onClick,
  setOtpReceived,
  requestFromCHPayment = true,
}) => {
  const length = 6; // Length of OTP
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const [timeLeft, setTimeLeft] = useState(120); // Timer for resend button
  const inputsRef = useRef(new Array(length).fill(React.createRef()));

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false; // If not a number, don't process

    // Update OTP array
    const newOtp = [
      ...otp.map((d, idx) => (idx === index ? element.value : d)),
    ];
    setOtp([...newOtp]);
    setOtpEntered(newOtp.join(""));

    // Focus next input on value entry, previous if empty (backspace/delete)
    if (element.value !== "") {
      // Move to next input if available
      if (element.nextSibling) {
        element.nextSibling.focus();
      }
    } else if (element.previousSibling) {
      // Move to previous input on backspace/delete if available
      element.previousSibling.focus();
    }
  };

  useEffect(() => {
    // Automatically focus the first input on component mount
    inputsRef.current[0].focus();
  }, []);
  useEffect(() => {
    // Timer logic
    let interval;
    if (timeLeft === 0 && !requestFromCHPayment) {
      setOtpReceived(null);
    } else if (timeLeft > 0) {
      interval = setInterval(() => {
        setTimeLeft((timeLeft) => timeLeft - 1);
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeLeft]);

  const handleResendClick = () => {
    // Resend OTP logic here
    if (timeLeft <= 0) {
      // Call handleInitialLogin to resend OTP
      onClick();
      setTimeLeft(120); // Reset the timer
    }
  };
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData
      .getData("text/plain")
      .slice(0, length)
      .split("");
    if (pastedData?.length === length) {
      setOtp([...pastedData]);
      setOtpEntered(pastedData.join(""));
      inputsRef.current[length - 1].focus();
    }
  };

  return (
    <>
      <label>Please Enter Your 6-Digit OTP:</label>
      <InputGroup className="gap-5 mt-5">
        {Array.from({ length }, (_, index) => (
          <Form.Control
            key={index}
            type="text"
            maxLength="1"
            style={{
              width: "3rem",
              textAlign: "center",
              borderRadius: "0.25rem",
            }}
            value={otp[index]}
            onChange={(e) => handleChange(e.target, index)}
            onKeyDown={(e) => {
              // When the user presses backspace and the input is empty, focus the previous input
              if (e.key === "Backspace" && !otp[index]) {
                const prevInput = inputsRef.current[index - 1];
                if (prevInput) {
                  prevInput.focus();
                }
              }
            }}
            onPaste={handlePaste}
            ref={(ref) => (inputsRef.current[index] = ref)}
            className="inputStyle form-control input-lg p-5"
          />
        ))}
      </InputGroup>
      <Button
        variant="link"
        className="w-100 text-decoration-underline text-end p-0"
        onClick={handleResendClick}
        disabled={timeLeft > 0}
      >
        {timeLeft > 0 ? `Resend OTP in ${timeLeft}s` : "Resend OTP"}
      </Button>
    </>
  );
};

export const FooterComp = ({ applyStyling = false, showTicketBtn = true }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const sidebarVisibility = useSelector((state) => state.RS_Sidebar.show);
  const sidebarWidth = useSelector((state) => state.RS_Sidebar.sidebarWidth);
  const email = useSelector(
    (state) => state.RS_Authentication.user.details.email,
  );

  async function handleTokenGenerationForVOM() {
    setLoading(true);
    try {
      const payload = {
        email_address: email,
      };

      const res = await axiosInstance.post(
        urls.VOM.generateTokenForVOM,
        payload,
      );
      localStorage.setItem("vom_token", res?.data?.tokenForVOM);
      navigate(`/vom/${email}`);
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  }

  return (
    <footer
      className="footer bg-white border-top fixed-bottom px-5 py-4"
      style={
        applyStyling
          ? {
              marginLeft: sidebarVisibility
                ? "calc(" + sidebarWidth + ")"
                : "0px",
            }
          : null
      }
    >
      <div className="container d-flex flex-column flex-md-row align-items-center justify-content-between py-3">
        {/* Quick actions */}
        <div className="d-flex gap-5 align-items-center mb-2 mb-md-0">
          {showTicketBtn && (
            <a
              href={"https://helpdesk.loanlinq.com"}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline-primary btn-sm d-flex align-items-center"
              title="Go to Helpdesk Portal" // Tooltip for better accessibility
            >
              <i className="bi bi-ticket-fill me-2"></i> Create a Ticket
            </a>
          )}

          <button
            // href={"/vom-gateway"}
            // target="_blank"
            // rel="noopener noreferrer"
            className="btn btn-outline-primary btn-sm d-flex align-items-center"
            title="Request VOM"
            onClick={handleTokenGenerationForVOM}
          >
            {loading ? (
              <div
                style={{ height: "1.2rem", width: "1.2rem" }}
                className="spinner-border pe-3"
                role="status"
              />
            ) : (
              <i className="bi bi-file-earmark-text me-2"></i>
            )}{" "}
            Request Verification of Mortgage
          </button>
        </div>

        {/* Small legal / links */}
        <div className="text-muted small">
          <a
            className="text-muted me-3"
            href="https://superiorloanservicing.com/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy
          </a>
          <a
            className="text-muted me-3"
            href="https://superiorloanservicing.com/terms-of-service"
            target="_blank"
            rel="noreferrer"
          >
            Terms
          </a>
          <span>© {new Date().getFullYear()} LoanlinQ</span>
        </div>
      </div>
    </footer>
  );
};
